import { WEB_SERVER_SECRET_HEADER } from '@shared/all/domains/ddosMode';

/**
 * The Next.js server's own credential for its anonymous API calls
 * (.specs/ddos-mode.md): with DDoS mode on, the API refuses a logged-out
 * caller, and a server render is one. `WEB_SERVER_SECRET` has no NEXT_PUBLIC_
 * prefix, so it is undefined in every browser bundle and the header is only
 * ever sent from the server. Unset = no header, and the render is refused like
 * any other logged-out caller.
 */
export const webServerHeaders = (): Record<string, string> => {
  const secret = process.env.WEB_SERVER_SECRET;
  return secret ? { [WEB_SERVER_SECRET_HEADER]: secret } : {};
};
